module.exports = __webpack_public_path__ + "img/blue_back.f876f50d.jpg";